import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuthContext } from '@/providers/Global'

//	///////////////////////
//	MARK: EXPORTS
const LoggedOutRouteInternal: React.FC<React.PropsWithChildren<{ children?: React.ReactNode }>> = ({
  children,
}) => {
  const location = useLocation()
  const Auth = useAuthContext()

  if (Auth.active) {
    return <Navigate to='/' state={{ message: 'e.you_must_log_out', from: location }} replace />
  }

  return <>{children}</>
}

export const LoggedOutRoute = React.memo(LoggedOutRouteInternal) as typeof LoggedOutRouteInternal

//	///////////////////////
//	MARK: HOC
export function withLoggedOutRoute<P>(Component: React.FC<P>): React.FC<P> {
  const value: React.FC<P> = (props) => (
    <LoggedOutRoute>
      {/* @ts-expect-error */}
      <Component {...props} />
    </LoggedOutRoute>
  )

  return value
}
